import * as types from '../mutation-types'

const state = {
    // 库存项目列表
    menuList: [],
    // 当前库存项目
    currentItem: 1,
    // 库存项目id
    currnetId: '',
    shopId: '',
    shopName: '',
}
const getters = {
    menuList: state => state.menuList,
    currentItem: state => state.currentItem,
    currnetId: state => state.currnetId,
    shopId: state => state.shopId,
    shopName: state => state.shopName,
}

const mutations = {
    // 接受一个状态 true/false
    setStoreList: (state, payload) => {
        state.menuList = payload
    },
    setCurrentItem: (state, n) => {
        state.currentItem = n
    },
    setCurrnetId: (state, n) => {
        state.currnetId = n
    },
    setShopId: (state, n) => {
        state.shopId = n
    },
    setShopName: (state, n) => {
        state.shopName = n
    },
}

const actions = {
    setStoreList: (context, payload) => {
        context.commit("setStoreList", payload)
    },
    setCurrnetId: (context, payload) => {
        context.commit("setCurrnetId", payload)
    },
    setShopId: (context, payload) => {
        context.commit("setShopId", payload)
    },
    setShopName: (context, payload) => {
        context.commit("setShopName", payload)
    },
}



export default {
    state,
    mutations,
    actions,
    getters
}